import axios from "@/api/axios";

const API_URL = process.env.VUE_APP_API_HOST;

/**
 * @param {Object} params
 * @param {number} params.page
 * @param {number} params.perPage
 * @param {string[]} params.sectors
 * @param {number[]} params.unitIds
 * @param {string} params.searchQuery
 * @param {AbortSignal} params.signal
 */
export async function getMachinesApi({
  sectors,
  unitIds,
  // page = 1,
  // perPage = 15,
  // searchQuery = "",
  signal = null,
}) {
  return await axios.get(`${API_URL}/api/admin/machines`, {
    params: {
      // "page[number]": page,
      // "page[size]": perPage,
      sectors: sectors,
      "company-ids": unitIds,
      // search: searchQuery,
      reduced: true,
      not_paginated: true,
      not_gallery: true,
    },
    signal,
  });
}
